import { updateClientCityToCityRequest } from "../../data/clientCityToCityApi";
import { validateClientCityToCityPayload } from "../validator/validateClientCityToCityPayload";

export async function updateClientCityToCityUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id de la tarifa de ciudad es obligatorio.");
  }

  const error = validateClientCityToCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateClientCityToCityRequest(payload);
}
